import { Box,TextField, Typography,Button } from '@mui/material'
import React, { useState } from 'react'
import QRCode from 'qrcode'
import RegisterRefugee from '../Components/RegisterRefugee/RegisterRefugee'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
export default function Register() {
    const [qr,setQr]=useState()
    const history=useHistory();
    const createQR=()=>{
        QRCode.toDataURL(`https://astha-bd.web.app/id/A4FJVY7`).then((url)=>{
            setQr(url)
        })
    }
    /*
     <Box sx={{width:"100vw",minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",margin:{md:"7vh"}}}>
        <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",marginBottom:"5vh"}}>
            <Typography variant="h4" color="primary">Register</Typography>
            <Typography variant="p" >Register new refugees here</Typography>
        </Box>
        <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <TextField label="Name" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
            <TextField label="Image URL" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
            <TextField label="Father's Name" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
            <TextField label="Mother's Name" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
            <TextField label="Location" variant="outlined" fullWidth sx={{margin:"1vh"}}/> 
        </Box>
        <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",alignItems:"center",justifyContent:"space-around",margin:"2vh"}}>
            <Button vatriant="contained" onClick={createQR} > Submit </Button>
        </Box>
        <Box sx={{width:{sm:"80vw",md:"60vw"},display:"flex",alignItems:"center",justifyContent:"space-around",margin:"2vh"}}>
            <RegisterRefugee/>
        </Box>
        <Box>
            <img id="qrCanvas" src={qr}/>
          
        </Box>
    </Box>
    */
  return (
    <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",width:"100vw",height:"100vh"}}>
        <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"15vh",marginTop:{md:"7vh"}}}>
            <Typography variant="h4" color="primary">Refugee Registration Service</Typography>
            <Typography variant="p">A verification sevice for refugees</Typography>
        </Box>
        <Box sx={{display:"flex",flexDirection:{xs:"column",md:"row"},height:{xs:"90vh",md:"80vh"}}}>
            <Box sx={{width:{xs:"100vw",md:"50vw"},height:{xs:"40vh",md:"80vh"},backgroundImage:`url("https://i.postimg.cc/sxynG3DQ/portrait-little-homeless-boy.jpg")`,backgroundPosition:"center",display:"flex",alignItems:"center",justifyContent:"center"}}>
                
                <Button variant="contained" sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:{xs:"15vh",md:"15vh"},width:{xs:"65vw",md:"30vw"}}} onClick={()=>history.push('/register/registrationForm')}>
                    <Typography sx={{fontSize:13}}>I am a refugee </Typography>
                    <Typography variant="h5">I want to register myself </Typography>
                </Button>
            </Box>
            <Box sx={{width:{xs:"100vw",md:"50vw"},height:{xs:"40vh",md:"80vh"},backgroundImage:`url("https://i.postimg.cc/BQSYqZVR/court-hammer-books-judgment-law-concept.jpg")`,backgroundPosition:"center",display:"flex",flexDirection:{xs:"column",md:"row"},alignItems:"center",justifyContent:"center"}}>
                <Button variant="contained" sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:{xs:"15vh",md:"15vh"},width:{xs:"65vw",md:"30vw"}}} onClick={()=>history.push('/register/verifyRegistration')}>
                    <Typography sx={{fontSize:13}}>I am an enlister </Typography>
                    <Typography variant="h5">I want to verify a registration </Typography>
                </Button>
            </Box>
        </Box>
    </Box>
  )
}
